import { useQuery } from "@apollo/client";
import Box from "@material-ui/core/Box";
import Button, { ButtonProps } from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import React from "react";
import { CHAINS_QUERY } from "./queries";

export function filterResources(resources: any[], group: string) {
  return group
    ? (resources || []).filter(
      (resource: any) => (resource.name.indexOf(group) !== -1)
    )
    : resources || [];
}

export const ActiveGroup = ({
  group,
  setGroup,
}: {
  group: string;
  setGroup: (v: string) => any;
}) => {
  const toggleGroup = (v: string) => {
    setGroup(group === v ? "" : v);
  };
  return (
    <Box display="flex" overflow="auto" maxWidth="100%">
      <Box pr={1}>
        <ActiveButton
          active={group === 'Ethereum'}
          onClick={() => toggleGroup('Ethereum')}
        >
          <Typography noWrap>{'Ethereum'}</Typography>
        </ActiveButton>
      </Box>
      <Box pr={1}>
        <ActiveButton
          active={group === 'Binance'}
          onClick={() => toggleGroup('Binance')}
        >
          <Typography noWrap>{'Binance'}</Typography>
        </ActiveButton>
      </Box>
      <Box pr={1}>
        <ActiveButton
          active={group === 'Polygon'}
          onClick={() => toggleGroup('Polygon')}
        >
          <Typography noWrap>{'Polygon'}</Typography>
        </ActiveButton>
      </Box>
    </Box>
  );
}

export const ActiveChainFilter = ({
  chainId,
  setChainId,
}: {
  chainId: string;
  setChainId: (v: string) => any;
}) => {
  const { data } = useQuery(CHAINS_QUERY);
  const toggleChainId = (v: string) => {
    setChainId(chainId === v ? "" : v);
  };
  return (
    <Box display="flex" overflow="auto" maxWidth="100%">
      {data?.chains?.map((chain: { chainId: string; name: string }) => (
        <Box pr={1} key={chain.chainId}>
          <ActiveButton
            active={chainId === chain.chainId}
            onClick={() => toggleChainId(chain.chainId)}
          >
            <Typography noWrap>{chain.name}</Typography>
          </ActiveButton>
        </Box>
      ))}
    </Box>
  );
};

export const ActiveButton = ({
  children,
  active,
  ...props
}: ButtonProps & { active: boolean }) => {
  return (
    <Button variant={active ? "contained" : "text"} {...props}>
      {children}
    </Button>
  );
};
